// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__mDqHh","spin":"Spinner_spin__5cNrQ"};